"use client";
import React from 'react';
import Globals from '../../../utility/constants/appConstants';
import nopaymentCss from "../../../styles/Payments/noPayment.module.scss";

function NoPaymentDue({ labels }) {
  return (
    <div className='row'>
      <div className='col'>
        <div className={`row mb-16 ${nopaymentCss['tru-mma-main-content-box']}`}>
          <div className={`align-items-center col-12 col-md-8 col-lg-9 d-flex gfw-3 p-30 text-center ${nopaymentCss['text-md-left']} ${nopaymentCss['tru-mma-main-content']}`}>
            <div className='align-items-center row'>
              <div className='col-12 col-md-2 text-center'>
                <img src='/images/MyAccount/Icons/ico-success-notify.png' className='mb-10 mb-md-0' width='48' height='48' />
              </div>
              <div className='col-12 col-md-10'>
                <span className={`${nopaymentCss['mob-gfs-22']} ${nopaymentCss['gfs-lg-30']} ${nopaymentCss['glh-1']}`}>{labels.noPaymentsMessage}</span>
              </div>
            </div>
          </div>
          <div className={`${nopaymentCss['bg-white']} col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-end p-0 ${nopaymentCss['tru-mma-main-side']}`}>
            <div className={`align-items-center d-flex flex-column flex-fill justify-content-center ${nopaymentCss['p-20']}`}>
              <span className={`d-block ${nopaymentCss['gfs-14']} ${nopaymentCss['gfs-lg-16']}`}>{labels.dueNow}</span>
              <span className={`d-block ${nopaymentCss['gfs-50']} ${nopaymentCss['gfs-md-26']} ${nopaymentCss['gfw-7']}`}>
                <span className={`${nopaymentCss['gfs-48']} ${nopaymentCss['glh-1-2']}`}>{Globals.currencySymbol}{labels.dollarsPP}</span>
                <sup className={`${nopaymentCss['gfs-26']} tg-ml-2`}>{labels.centsPP}</sup>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoPaymentDue;